import React, {useRef, useState, useEffect } from 'react';
import DataGrid, {Column, MasterDetail, Lookup, Button} from 'devextreme-react/data-grid';
import CountryService from '../../../utils/country';
import './index.scss';

const ShipmentDetails = (props) => {
    const data = props.data.data;
    const [detailData,setDetailData] = useState([]);
    useEffect(() => {
        var arrayData = [];
        arrayData.push({
            "_id": data._id,
            "userId": data.userId,
            "name": data.name,
            "country": data.country,
            "serviceType": data.serviceType,
            "weight_units": data.weight_units,
            "weight_value": data.weight_value,
            "size_units": data.size_units,
            "size_length": data.size_length,
            "size_width": data.size_width,
            "size_height": data.size_height,
            "cost": data.cost,
            "warehouseReceiveTimes" : data.warehouseReceiveTimes
        })
        setDetailData(arrayData);
    }, [data]);
    
    const getCountry = () => {
        return {store: CountryService, pageSize: 10, paginate: true}
    }
    const trackingNoLink = (data) => {
        var no = data.data.tracking_number;
        var service = data.data.service;
        if (service
            ?.includes('USPS')) {
            return (
                <div>
                    <a
                        target="_blank"
                        href={`https://tools.usps.com/go/TrackConfirmAction.action?tLabels=${no}`}>{no}</a>
                </div>
            );
        } else if (service?.includes('4PX')) {
            return (
                <div>
                    <a target="_blank" href={`http://track.4px.com/#/result/0/${no}`}>{no}</a>
                </div>
            );
        } else {
            return (
                <div>
                    {no}
                </div>
            );
        }
    }

    const calcWeight = (data) => {
        var value = data?.weight_value ?  data.weight_value :0;
        var unit = data?.weight_units;
        return `${value} ${unit}`;
    };

    const calcSize = (data) =>{
        var l = data?.size_length ?  data.size_length :0;
        var w = data?.size_width ? data?.size_width: 0
        var h = data?.size_height ?  data.size_height :0;
        var unit = data?.size_units;
        return `${l}x${w}x${h} ${unit}`;
    };
    
    return (
        <DataGrid 
        dataSource={detailData}
         showBorders={true}
         allowColumnResizing={true}
         columnAutoWidth={true}
         columnResizingMode={'nextColumn'}>
            <Column dataField={'name'}/>
            <Column dataField={'country'}>
                <Lookup dataSource={getCountry} displayExpr={'name'} valueExpr={'iso2'}/>
            </Column>
            <Column dataField={'warehouseReceiveTimes'} width={'15vw'} dataType={'datetime'}/>
            <Column dataField={'weight_units'} caption={'Weight'} calculateCellValue={calcWeight}/>
            <Column dataField={'size_units'} caption={'Size'} calculateCellValue={calcSize}/>
            <Column dataField={'cost'} caption={'Shipping Cost'} format="currency"/>
        </DataGrid>
    )
}
export default ShipmentDetails;